import type { clients } from "@codesandbox/pitcher-client";
import { useNotifications } from "features/notifications/Feature";
import { usePitcher } from "features/utils/usePitcher";
import * as React from "react";

export type HandleNotification = (notification: clients.INotification) => void;

export const usePitcherNotifications = () => {
  const pitcher = usePitcher();
  const [_, notificationDispatch] = useNotifications();

  React.useEffect(() => {
    const disposable = pitcher.clients.notification.onNotification(
      (notification) => {
        notificationDispatch({
          type: "ADD_NOTIFICATION",
          notification: {
            message: notification.message,
            type:
              notification.type === "info" &&
              notification?.actions?.length === 0
                ? "STATUS"
                : "ALERT",
            showDismiss: true,
            uniqueName: notification.id,

            callback: () => {
              // Dismiss has been pressed
              notification.respond(null);
            },

            actions:
              notification.actions?.map((action) => {
                return {
                  text: action.label,
                  onAction: () => {
                    notification.respond(action.label);
                  },
                };
              }) || [],
          },
        });
      },
    );

    const dimissDisposable = pitcher.clients.notification.onDismissNotification(
      ({ notificationId }) => {
        notificationDispatch({
          type: "DISMISS_NOTIFICATION",
          uniqueName: notificationId,
        });
      },
    );

    return () => {
      disposable.dispose();
      dimissDisposable.dispose();
    };
  }, []);
};
